<script setup lang="ts">
import Product from "~/models/Product";
import { useMounted } from "@vueuse/core";
import ProductRating from "@/components/common/product/ProductRating.vue";

defineProps({
  product: {
    type: Product,
    required: true,
  },
});
const mounted = useMounted();
</script>

<template>
  <!-- PRODUCT NAME, PART AND RATING -->
  <header>
    <h1 class="fs-3 fw-semibold border-bottom border-light-subtle pb-2">
      {{ product.name }}
    </h1>
    <section
      v-if="product.seo_descriptive_title"
      class="visually-hidden"
      aria-label="Descripción complementaria del producto"
      data-seo-descriptive-title
    >
      <p class="mb-0">{{ product.seo_descriptive_title }}</p>
    </section>
    <!-- SEO: PARTE, MARCA Y CATEGORÍA DE PRODUCTO -->
    <dl
      class="seo-part-brand-cat mb-2 mb-md-3 small-sm text-center d-flex flex-nowrap"
      aria-label="Especificaciones principales del producto"
      data-seo-specs
    >
      <dt class="fw-semibold d-inline text-nowrap">Número de parte:</dt>
      <dd class="d-inline text-secondary ms-1 text-nowrap">
        {{ product.part_number }}
      </dd>
      <template v-if="product.brand?.name">
        <dt class="fw-semibold d-inline text-nowrap ms-2">Marca:</dt>
        <dd class="d-inline text-secondary ms-1 text-nowrap">
          {{ product.brand.name }}
        </dd>
      </template>
      <template v-if="product.category?.name">
        <dt class="fw-semibold d-inline text-nowrap ms-2">Categoría:</dt>
        <dd class="d-inline text-secondary ms-1 text-nowrap">
          {{ product.category.name }}
        </dd>
      </template>
    </dl>
    <product-rating
      v-if="mounted"
      :rating="product.rating"
      :label="product.reviews_count + ' opiniones'"
      class="mb-3"
    />
  </header>
</template>

<style scoped>
/** Comportamiento de seo-part-brand-cat para móviles y escritorio */

/** Overflow auto en moviles */
@media (max-width: 576px) {
  .seo-part-brand-cat {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

/** Ellipsis en escritorio  */
@media (min-width: 577px) {
  .seo-part-brand-cat {
    dd:last-child {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &:hover {
      dd:last-child {
        overflow: visible;
        white-space: normal;
        text-overflow: clip;
      }
    }
  }
}
</style>
